import styled from 'styled-components';
import { vars } from '@agendor/ui';

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const InputGroup = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-weight: 600;
    font-size: 0.9rem;
    color: ${vars.foregroundColor};
`;

export const ErrorText = styled.span`
    font-size: 0.85rem;
    font-weight: 400;
    color: ${vars.dangerColor};
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
`;

export const ConfirmSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 16px;
`;

export const ConfirmLabel = styled.div`
    font-size: 0.9rem;
    font-weight: 600;
    color: ${vars.foregroundColor};
`;

export const ConfirmValue = styled.div`
    padding: 8px 12px;
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.05);
    color: #666;
    font-size: 0.95rem;
`;

export const NotesTextArea = styled.textarea`
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${vars.dividerColor};
    border-radius: 6px;
    font-size: 0.95rem;
    font-family: inherit;
    resize: vertical;
    min-height: 60px;
    background-color: rgb(255, 255, 255);
    color: ${vars.foregroundColor};
    box-sizing: border-box;
    &::placeholder {
        color: #999;
    }
    &:focus {
        outline: none;
        border-color: ${vars.accentColor};
    }
`;
